export default __webpack_public_path__ + "assets/m3.fd6bb84e.png";